import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import BlogItem from "../components/blog-item"
import Seo from "../components/seo"

export const fragment = graphql`
  fragment post on WpPost {
    title
    excerpt
    date
    readableDate: date(formatString: "DD MMMM, YYYY")
    categories {
      nodes {
        uri
        name
        parentId
        slug
      }
    }
    featuredImage {
      node {
        sourceUrl
        mediaDetails {
          sizes {
            sourceUrl
            name
            mimeType
            height
            fileSize
            file
            width
          }
        }
        small: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 320
              height: 200
              placeholder: BLURRED
            )
          }
        }
        medium: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 320
              height: 180
              placeholder: BLURRED
            )
          }
        }
        large: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 600
              placeholder: BLURRED
            )
          }
        }
        xl: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 910
              placeholder: BLURRED
            )
          }
        }
        altText
        caption
        databaseId
        id
      }
    }
    author {
      node {
        name
        description
      }
    }
    commentCount
    content
    slug
  }
`

export default function Blog({ data }) {
  return (
    <Layout>
      <Seo
        title={`Blog`}
        description={"Latest posts from the Nightnightystories.com blog"}
      />
      <header className="bg-white dark:bg-gray-900 dark:text-white  mb-12">
        <h1 className="text-3xl lg:text-8xl  text-gray-900 dark:text-white mb-8">
          Blog
        </h1>
      </header>
      <div
        className={"border-4 border-dashed border-gray-200 rounded-lg p-8 pb-0"}
      >
        {data.allWpPost.nodes.map(node => (
          <BlogItem key={node.slug} post={node} />
        ))}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allWpPost(sort: { order: DESC, fields: date }) {
      nodes {
        ...post
      }
      distinct(field: commentCount)
    }
  }
`
